import { graphqlApolloClient as client } from "../graphql-apollo-client"
import { UPDATE_BENEFICIARIES_F21 } from "./graphql/mutations/update-beneficiaries-f21-mutation"

/**
 * @param {{
 * beneficiaryData: object,
 * expectedChangeData: object,
 * requiredActivitiesData: object,
 * generalObjectiveIndicatorsRelationship: object
 * }[]} data
 */
export const updatedBeneficiariesF21 = async (data = []) => {
  const result = await client.mutate({
    mutation: UPDATE_BENEFICIARIES_F21,
    variables: {
      data
    }
  })

  return result.data?.beneficiaries || []
}